import avatar1 from "../assets/images/user.png";


export const staticData = [
    {
        name: 'දිනුවන් සාමෙන්ද 2022(2023)',
        school: '',
        image: avatar1,
        description1: 'මම 10 වසරේදි තමා සර්ගේ class එකට ආවේ. 9 වසරේ ඉඳන් ගියපු class එක සෙට් උනේ නෑ. ක්ලාස් එකට ගියාට පස්සේ සර් අපිට බැරිවෙච්චි පාඩම් ඔක්කොම කියලා දුන්නා.',
        description2: 'Science විතරක් නෙවෙයි maths එක්ක අනිත් හැම විෂයකටම full support එක දුන්නේ සර්. කොහොමහරි science, maths එක්කම A 7, B 2ක result එකක් ලැබුණා. Thank you sir හැමදේකටම'
    },
    {
        name: 'Dinunwan',
        school: '',
        image: avatar1,
        description1: 'මේක තමා මම දැකපු සුපිරිම science class එක. මම කලින් science class ගියා, හැබැයි ඒ එකක්වත් practical කලේ නෑ. Sir පොතේ තියෙන හැම practical එකක්ම අපිට කරන්න දුන්නා.',
        description2: 'Paper class එක නම් සුපිරි, sir ඒක free කලා. ඒක ගොඩක් help උනා කලින් කරපු පාඩම් මතක තියාගන්න. Paper class එක සතියට සැරයක් තියලා ලකුණු දීලා අපිව ගොඩවැම්මට තැන්ක්ස් සර්.'
    },
    {
        name: 'Amila Drshana 2022(2023) O/L',
        school: '',
        image: avatar1,
        description1: 'මට නම් O/L maths වලට ලකුණු 10-15, science වලට 20-25 වගේ තිබුණේ. සර්ව හම්බ උනේ දහය වසරේ අන්තිම වාරෙ. සර් කියපු විදියට අන්තිම මාස ටිකේ වැඩ කරලා මහන්සි වෙලා, අන්තිමට fail වෙන්න තිබ්බ subject 2ට A pass දෙකක් දාගත්තා.',
        description2: 'Thank you so much sir. සර් අපිට extra classes දාලා, papers ලියවලා, revision classes කරලා, සර් කියලා දුන්නු කෙටි ක්‍රම වලින් exam එකට ගේමක් ගහන්න පුළුවන් උනා.'
    },
    {
        name: 'Rashmika Aththanayaka',
        school: '',
        image: avatar1,
        description1: 'මම සර්ගේ class ආවේ 10 වසරේ දෙවනි වාරෙට. මට මුලින්ම ලකුණු තිබුණේ විස්සටත් අඩුවෙන්. සර්ගේ class ආව දවසේ ඉඳලා science ආසාව වැඩිවුණා. නැත්තම් මට science එපා වෙලාම තිබුණු subject එක.',
        description2: 'සර්ගේ notes ටික නම් පට්ට sir. ඒවගෙන් තමා science ගොඩදාගත්තෙ. 1980 ඉඳලා 2022 O/L වලට තිබුණු හැම ප්‍රශ්නයක්ම සර් කරපු නිසා තමා සර් ගොඩගියේ.'
    }
]